export const home = {
    title1:'home',
    title2:'Department',
    title3:'Product',
    title4:'questionnaire ',
    title5:'language',
    welcome:'Welcome to this website',
    login:'login/register'

}
export const center = {
    title1:'About us',
    title2:'Department display',
    title3:'Product display',
    more:'more',
    titlex:'questionnaire investigation'
}

export const bottom = {
    address:'address',
    email:'email',
    phone:'telephone',
    Postal :'postal '
}

export const paper = {
    submit:'Confirm submission',
    btn:'participate in activities',
    tips:'Submitted successfully'
}
export const login = {
    title:'Account login',
    email:'email',
    pwd:'password',
    titlel:'Account registration',
    titler:'Forgot password',
    btn:'Login'
}
export const register = {
    title:'Account registration',
    code:'Verification ',
    email:'email',
    pwd:'password',
    pwd2:'Enter',
    titlel:'Account login',
    titler:'Forgot password',
    btn:'register',
    codeTips:'Get'
}
export const forgot = {
    title:'Forgot password',
    code:'Verification',
    email:'email',
    pwd:'Old Password',
    pwd2:'Password',
    titlel:'Account login',
    titler:'Forgot password',
    btn:'Confirm modification',
    codeTips:'Get'
}
export const active = {
    tips:'Mr. Zhang received a reward of $100 through the questionnaire!',
    title1:'Sign',
    title2:'Complete the login task',
    title3:'Get a $50 bonus',
    title4:'Participate ',
    title22:'Complete the check-in task',
    title23:'Complete the upgrade task',
    popup1:'Successfully registered, you will get a reward of $100; Go and finish other tasks!',
    popup2:'Sign in today to receive 20 points',
    popup3:'Sorry, the current membership level is not enough to enter the corresponding task. Please contact customer service immediately!',
    popup1Btn:'I got it!',
    popup2Btn:'I got it!',
    popup3Btn:'Contact customer service',
}


// WEBPACK FOOTER //
// ./src/i18n/English.js